/**
 * Read a CSS custom property (e.g. `--color-orange`) off the root element,
 * as set by the `@theme {}` tokens in src/index.css, falling back when it
 * resolves empty (e.g. property not defined).
 * @param {string} name     CSS custom property name, including the `--`.
 * @param {string} fallback Value to use if the property is unset.
 */
export function themeColor( name, fallback ) {
	const value = getComputedStyle( document.documentElement )
		.getPropertyValue( name )
		.trim();
	return value || fallback;
}
